// extracted by mini-css-extract-plugin
export default {"topBtn":"style_topBtn__jisDU","arrow":"style_arrow__0A5Gv"};